












import { Vue, Component, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'

type O2C = {
  readonly MedicalDoctor: string
  readonly Dentist: string
  readonly Pharmacist: string
  readonly Nurse: string
  readonly PhysicalTherapist: string
  readonly OccupationalTherapist: string
  readonly CertifiedCareWorker: string
  readonly ClinicalEngineer: string
  readonly CareManager: string
}

@Component
export default class UserIcon extends Vue {
  $store!: ExStore

  readonly o2c: O2C = {
    MedicalDoctor: 'icon_lightblue',
    Dentist: 'icon_blue',
    Pharmacist: 'icon_lightgreen',
    Nurse: 'icon_lightgreen',
    PhysicalTherapist: 'icon_beige',
    OccupationalTherapist: 'icon_yellow',
    CertifiedCareWorker: 'icon_orange',
    ClinicalEngineer: 'icon_purple',
    CareManager: 'icon_yellowgreen'
  }

  @Prop({ default: 0 })
  id!: number

  @Prop({ default: '' })
  occupation!: string

  @Prop({ default: '' })
  occupationShortName!: string

  @Prop({ default: '' })
  name!: string

  get iconColorCss() {
    return this.o2c[this.occupation as keyof O2C] || 'icon_lightblue'
  }

  get onlineStatus() {
    return this.$store.getters['onlineStatus/onlineStatus']
  }

  get isOnline() {
    return this.onlineStatus[this.id] && this.onlineStatus[this.id].isOnline
  }

  //TODO: colorを実装
}
